import { render, staticRenderFns } from "./newTask.vue?vue&type=template&id=1892e413&scoped=true"
import script from "./newTask.vue?vue&type=script&lang=js"
export * from "./newTask.vue?vue&type=script&lang=js"
import style0 from "./newTask.vue?vue&type=style&index=0&id=1892e413&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1892e413",
  null
  
)

export default component.exports